import React from "react";

const MediaBlock = ({ media = [] }) => {
  if (!media.length) return null;

  return (
    <div className="flex gap-2 flex-wrap mt-2">
      {media.map((url, i) => {
        const isImage = /\.(jpg|jpeg|png|gif|webp|avif)$/i.test(url);
        const isVideo = /\.(mp4|webm|ogg)$/i.test(url);
        const isPdf = /\.pdf$/i.test(url);

        if (isImage) {
          return (
            <img
              key={i}
              src={url}
              alt="media"
              className="w-24 h-24 object-cover rounded-lg border"
            />
          );
        }

        if (isVideo) {
          return (
            <video
              key={i}
              src={url}
              controls
              className="w-32 h-24 rounded-lg border"
            />
          );
        }

        if (isPdf) {
          return (
            <a
              key={i}
              href={url}
              target="_blank"
              rel="noreferrer"
              className="px-3 py-2 border rounded-lg bg-blue-50 font-bold text-blue-700"
            >
              📄 {url.split("/").pop()}
            </a>
          );
        }

        return null;
      })}
    </div>
  );
};

export default MediaBlock;
